import * as Icons from "lucide-react";

export const Icon = ({ name, className = "w-5 h-5", ...rest }) => {
  const C = Icons[name] || Icons.Circle;
  return <C className={className} strokeWidth={1.75} {...rest} />;
};
